import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import NewCard from '../../../components/NewCard';
import TaskCard from './TaskCard';
import Analytics from '../../../helpers/analytics/analytics';
import dataModel from '../../../models/DataModel';
import BreadCrumbs from '../../../components/BreadCrumbs';
import { attributes_task_root } from  '../../../dao/TasksDAO';
import { build_root, attributes_build_root } from '../../../dao/BuildsDAO';
import ProjectTemplateHeader from '../../../containers/ProjectTypesContainer/ProjectTemplateHeader';
import DataSource from '../../../dao/DataSource/DataSource';
import './ProjectTemplateTasks.scss';

const projectTemplateDescriptor = {
  project_template: {
    builds: {
    },
    company: {},
    reference_documents: {},
    markets: {},
  },
};

export class ProjectTemplateTasks extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { 
      flattenedTasks: null,
      projectTemplate: null,
      build: null,
      tasksCount: 0,
    };
    this.analytics = new Analytics();
  }

  handleUpdateProjectTemplate(projectTemplate) {
    this.setState({ projectTemplate, banner: (!projectTemplate.published_at && !projectTemplate.publishing ? 'This Version has not yet been published.' : null) });

    if (this.state.path && this.state.path.params && this.state.path.params.build_id == 'all') {
      this.setState({ build: projectTemplate.root_build }, () => {
        this.setBuildAndTasks();
      });
    }
    else if (this.buildDataSource) {
      this.buildDataSource.get();
    }

  }

  handleUpdateProjectType(projectType) {
    this.setState({ projectType });
  }

  handleUpdateBuild(build) {
    this.setState({ build }, () => {
      this.setBuildAndTasks();
    });
  }

  handleInitializeDataSources() {
    if (this.projectTemplateDataSource) {
      this.projectTemplateDataSource.release();
    }
    if (this.projectTypeDataSource) {
      this.projectTypeDataSource.release();
    }
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }

    const path = this.props.history.parseParameters();

    this.setState({ path });

    if (path.params.project_template_id) {
      this.projectTemplateDataSource = new DataSource('ProjectTemplate', +path.params.project_template_id, projectTemplateDescriptor, this.handleUpdateProjectTemplate);
      this.projectTemplateDataSource.get();
    }

    if (path.params.project_type_id) {
      this.projectTypeDataSource = new DataSource('ProjectType', +path.params.project_type_id, { project_type: {} }, this.handleUpdateProjectType);
      this.projectTypeDataSource.get();
    }

    if (path.params.build_id && path.params.build_id != 'all') {
      this.buildDataSource = new DataSource('Build', +path.params.build_id, build_root, this.handleUpdateBuild);
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.handleInitializeDataSources();
  }

  componentWillUnmount() {
    if (this.projectTemplateDataSource) {
      this.projectTemplateDataSource.release();
      this.projectTemplateDataSource = null;
    }
    if (this.projectTypeDataSource) {
      this.projectTypeDataSource.release();
      this.projectTypeDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    //do I need the and?

    const path = this.props.history.parseParameters();
    if (this.state.path && path.params.project_template_id != this.state.path.params.project_template_id) {
      this.handleInitializeDataSources();
    }

    //get and set build using prop buildId
    if (prevProps.buildId != this.props.buildId) {
      this.setBuildAndTasks();
    }
  }

  async setBuildAndTasks() {
    const { build } = this.state;
    //if build exists and is not root build, show only build tasks
    if (build && (build.tasks || build.builds)) {
      this.tasks = [];
      await this.flattenTasks([build]);

      this.tasks.sort((t1, t2) => {
        // order by build ancestry first
        if (t1.build_order < t2.build_order) {
          return -1;
        }
        else if (t1.build_order > t2.build_order) {
          return 1;
        }
        else {
          return t1.order < t2.order ? -1 : t1.order > t2.order ? 1 : 0;
        }
      });
      this.setState({ flattenedTasks: this.tasks });
    }
  }

  async flattenTasks(builds) {
    if (builds) {
      for (let i = 0; i < builds.length; i++) {
        let build = builds[i];
        if (typeof build == 'number') {
          build = await dataModel.buildsDAO.getBuild(build, { recordDescriptor: build_root });
        }
        if (build && build.tasks_count && build.ancestry) {
          if (typeof build.tasks[0] == 'number') {
            build = await dataModel.buildsDAO.getBuild(build.id, { recordDescriptor: build_root });
          }
          for (let j = 0; j < build.tasks.length; j++) {
            let task = build.tasks[j];
            // Each getBuild above is awaited, so a sign-out can wipe the store mid-walk and leave
            // permissions gone by the time we get here.
            if (this.props.permissions && this.props.permissions.canViewTask) {
              task.build_order = build.order;
              this.tasks.push(task);
            }
          }
        }
        if (build && build.builds) {
          await this.flattenTasks(build.builds, true);
        }
      }
    }
  }

  async handleTaskSelect(task, projectTemplateIgnore, newTask) {
    let { build, projectTemplate } = this.state;

    if (!build || build == -1) {
      build = await dataModel.buildsDAO.getBuild(task.build_id, { recordDescriptor: build_root });
    }
    this.props.history.push({ pathname: '/project-types/' + projectTemplate.project_type_id + '/project-template/' + projectTemplate.id +
      '/build/' + build.id + '/task/' + task.id + (newTask ? '/edit' : '') });    
  }

  hasTasks(build) {
    if (build.tasks && build.tasks.length > 0) {
      return true;
    }
    else if (build.builds) {
      for (let i = 0; i < build.builds.length; i++){
        if (this.hasTasks(build.builds[i])){
          return true;
        }
      }
    }
  }

  handleCreateTask(name, parent) {
    const { projectTemplate } = this.state;
    if (parent) {
      let order = parent.tasks && parent.tasks.length > 0 ? parent.tasks.length  + 1 : 1;
      const newTask = {
        name: name, 
        build_id: parent.id, 
        order: order,
        location_id: null,
      };
      dataModel.tasksDAO.createTask(newTask, null, { recordDescriptor: attributes_task_root }).then(task => {
        this.props.history.push({
          pathname: '/project-types/' + projectTemplate.project_type_id + '/project-template/' + projectTemplate.id +
            '/build/' + task.build_id + '/task/' + task.id + '/edit',
        });  
      });
    }
    
    this.setState({ displayAddCard: false });
  }

  handleTaskDeleted(task) {
    this.setBuildAndTasks();
  }

  displayAllTasks() {
    const { flattenedTasks, displayAddCard, copiedTask } = this.state;
    let taskCards = null;
    this.draggableTasks = {};

    if (flattenedTasks) {
      taskCards = flattenedTasks.map(task => {
        this.draggableTasks[task.id] = task;
        let isTaskCopied = copiedTask && copiedTask.id == task.id ? true : false;
        return (
          <TaskCard 
            id={task.id}
            key={'not-started-' + task.id}
            taskId={task.id}
            handleDragging={this.handleDragging}
            handleDropping={this.handleDropping}
            handleDragCancel={this.handleDragCancel}
            handleTaskSelect={this.handleTaskSelect}
            handleTaskDeleted={this.handleTaskDeleted}
            handleAddCopiedTask={this.handleAddCopiedTask}
            isTaskCopied={isTaskCopied}
            readOnly={!!this.state.projectTemplate.published_at}
            currentUser={this.props.currentUser}
          />
        );
      });
    }

    if (displayAddCard) {
      const addCard = (
        <NewCard 
          id={'addNewTaskCard'} 
          key={'new-task-card'} 
          connectorClass={null}
          handleCancel={this.handleCancelAdd}
          handleCreate={this.handleCreateTask} 
          parent={this.state.build} 
          type={'task'}
        />
      );
      if (!taskCards) {
        taskCards = [];
      }
      taskCards.push(addCard);

    }
    return (
      <div className="column-contents" ref={ (element) => { this.scrollColumn = element; } }>
        <div className="column-inner-contents" ref={ (element) => { this.draggableContainer = element; } }>
          {taskCards}
        </div>
      </div>
    );
  }

  handleAddCopiedTask(newTask, originalTask) {
    const { flattenedTasks } = this.state;
    const copyFlatTasks = [...flattenedTasks];

    const originalTaskIndex = copyFlatTasks.findIndex(task => task.id == originalTask.id);
    copyFlatTasks.splice((originalTaskIndex+1), 0, newTask);

    this.setState({ flattenedTasks: copyFlatTasks, copiedTask: newTask });
  }

  handleEditCancel() {
    this.setState({ editing: false, editedBuild: null });
  }
  
  handleAddTask() {
    this.setState({ displayAddCard: true });
  }

  handleCancelAdd() {
    this.setState({ displayAddCard: false });
  }

  handleFindDragTarget(y) {
    const dragObject = this.draggableTasks[this.dragObject.id];
    const containerRect = this.draggableContainer.getBoundingClientRect();
    const normalizeY = y - containerRect.top + 40;
    let firstInList = true;
    for (let i = 0; i < this.state.flattenedTasks.length; i++){
      let id = this.state.flattenedTasks[i].id;
      if (id) {
        if (this.draggableTasks[id] && this.draggableTasks[id].build_id &&
          dragObject.build_id &&
          this.draggableTasks[id].build_id == dragObject.build_id) {
          const element = document.getElementById(id);
          if (element) {
            if (firstInList && normalizeY < element.offsetTop && normalizeY <= (element.offsetTop + element.offsetHeight / 2)) {
              this.dragBefore = true;
              return { item: this.draggableTasks[id], y: element.offsetTop, x: element.offsetLeft, height: element.offsetHeight, width: element.offsetWidth };
            }
            else if (normalizeY >= element.offsetTop && normalizeY <= (element.offsetTop + element.offsetHeight)) {
              this.dragBefore = false;
              return { item: this.draggableTasks[id], y: element.offsetTop, x: element.offsetLeft, height: element.offsetHeight, width: element.offsetWidth };
            }
            firstInList = false;
          }
        }
      }
    }
  }

  handleCreateDragIndicator() {
    this.lineElement = document.createElement('div');
    this.lineElement.style.width = '202px';
    this.lineElement.style.height = '6px';
    this.lineElement.style.backgroundColor = '#a7a7a7';
    this.lineElement.style.position = 'absolute';
    this.lineElement.style.zIndex = 999;
    this.draggableContainer.appendChild(this.lineElement);
  }

  handlePositionDragIndicator() {
    if (this.dragTarget) {
      let top = this.dragTarget.y + this.dragTarget.height + 2 - this.scrollColumn.scrollTop;

      if (this.dragBefore) {
        top = this.dragTarget.y - 8;
      }

      this.lineElement.style.top = top + 'px';
      this.lineElement.style.left = this.dragTarget.x + 'px';
    }
  }

  handleDragging(task, x, y) {

    // Start in one column, and stay in that column
    if (!this.dragX) {
      const rect = this.scrollColumn.getBoundingClientRect();
      this.dragObject = task;
      this.dragX = rect.left;
      this.dragTarget = this.handleFindDragTarget(y);
      this.handleCreateDragIndicator();
      if (this.dragTarget) {
        this.handlePositionDragIndicator();
      }
    }
    else {
      const newDragTarget = this.handleFindDragTarget(y);
      if ((newDragTarget && newDragTarget != this.dragTarget) || this.dragBefore) {
        this.dragTarget = newDragTarget;
        this.handlePositionDragIndicator();
      }
    }
    if (this.dragTarget) {
      const scrollerRect = this.scrollColumn.getBoundingClientRect();
      if (y + 20 + this.dragTarget.height > scrollerRect.bottom) {
        this.scrollColumn.scrollTop += (y + 20 + this.dragTarget.height) - scrollerRect.bottom;
        this.handlePositionDragIndicator();
      }
      else if (y < scrollerRect.top) {
        this.scrollColumn.scrollTop -= Math.abs(y - scrollerRect.top);
        this.handlePositionDragIndicator();
      }
    }
  }

  handleDragFinished() {
    this.draggableContainer.removeChild(this.lineElement);
    delete this.dragX;
    delete this.lineElement;
    delete this.dragTarget;
  }

  orderTasks(tasks, afterTask, insertedTask, orderedTasks) {
    let order = 1;
    if (!afterTask) {
      insertedTask.order = order;
      order++;
      orderedTasks.push(insertedTask);
      for (let i = 0; i < tasks.length; i++) {
        const copyTask = tasks[i];
        if (copyTask.id != insertedTask.id) {
          copyTask.order = order;
          orderedTasks.push(copyTask);
          order++;
        }
      }
    }
    else {
      for (let i = 0; i < tasks.length; i++) {
        const copyTask = tasks[i];
        if (copyTask.id != insertedTask.id) {
          copyTask.order = order++;
          orderedTasks.push(copyTask);
          if (copyTask.id == afterTask.id) {
            insertedTask.order = order++;
            orderedTasks.push(insertedTask);
          }
        }
      }
    }
  }

  async handleDropping(orderedTask, x, y) {
    if (this.dragTarget) {
      const parentBuild = await dataModel.buildsDAO.getBuild(orderedTask.build_id, { recordDescriptor: attributes_build_root });
      if (!parentBuild) {
        return;
      }
      let afterTask = this.dragBefore ? null : this.dragTarget.item;
      let reorderedTasks = {};

      // make sure there are no duplicate orders

      let order = 1;
      for (let task of this.state.flattenedTasks) {
        if (task.order != order) {
          task.order = order++;
          if (afterTask && afterTask.id == task.id) {
            afterTask = task;
          }
          else if (task.id == orderedTask.id) {
            orderedTask = task;
          }
          reorderedTasks[task.order] = task;
        }
        else {
          order++;
        }
      }

      let oldOrder = orderedTask.order;
      let newOrder = !afterTask ? 1 : afterTask.order > oldOrder ? afterTask.order : afterTask.order + 1;

      let startOrder = oldOrder < newOrder ? oldOrder : newOrder;
      let endOrder = oldOrder > newOrder ? oldOrder : newOrder;
      let currentOrder = oldOrder < newOrder ? oldOrder : newOrder + 1;
      for (let task of this.state.flattenedTasks) {
        let t = task;
        if (t.order >= startOrder && task.order <= endOrder && task.id != orderedTask.id) {
          task.order = currentOrder++;
          reorderedTasks[task.order] = task;
        }
      }

      orderedTask.order = newOrder;
      reorderedTasks[newOrder] = orderedTask;

      let reorderedArray = [];
      for (var key in reorderedTasks) {
        if (key) {
          let task = reorderedTasks[key];
          reorderedArray.push(task);
        } 
      }

      dataModel.tasksDAO.reorderTasks(reorderedArray, parentBuild).then(response => {
        // this.setBuildAndTasks(this.state.projectTemplate)
      });
    }
    this.handleDragFinished();
  }

  handleDragCancel() {
    this.handleDragFinished();
  }

  render() {
    let { banner } = this.state;
    //verify that the project template exists 
    if (!this.state.projectTemplate) {
      return null;
    }

    let subHeader = (
      <div className="project_template-tasks-subheader" >
        <BreadCrumbs history={this.props.history} menu={this.state.menu} />
      </div>
    );

    const allTasks = this.displayAllTasks();

    // Signing out dispatches USER_LOGOUT, which resets every store slice (rootReducer in
    // models/index.js), so `permissions` is undefined for the render that lands before this screen
    // unmounts. Default to an empty permission set so nothing privileged renders and nothing throws.
    const permissions = this.props.permissions ? this.props.permissions : {};

    let addButton = null;
    if (this.state.build && this.state.build.ancestry && permissions.canCreateTask && permissions.canEditProjectTemplate &&
      !this.state.projectTemplate.published_at) {
      addButton = <div className="column-footer">
        <div className='add-button-container' onClick={this.handleAddTask}>
          <div className={'add-button'} />
          <div className="add-label">{this.textMap.createTask}</div>
        </div>
      </div>;
    }
    
    return (
      <div className={'project_template-tasks'} >
        <ProjectTemplateHeader
          history={this.props.history}
          projectTemplate={this.state.projectTemplate}
          projectType={this.state.projectType}
          currentCompany={this.props.currentCompany}
          currentUser={this.props.currentUser}
        />
        {banner && <div className="project-types-banner">{banner}</div>}
        <div className={'project_template-tasks-container'}>
          {subHeader}
          <div className={'project_template-tasks-detail'}>
            <div className={'project_template-tasks-scroller' +
              (!this.state.projectTemplate.published_at && !this.state.projectTemplate.publishing ? ' not-published' : '')}>
              <div className="project_template-tasks-body">
                <div className="tasks-column column-1">
                  <div className="column-header">
                    <div className="caption">{'All Tasks'}</div>
                  </div>
                  {allTasks}
                  {addButton}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectTemplateTasks));



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTemplateTasks/index.js